import React from "react";
import { ResponsiveChoropleth } from "@nivo/geo";
import { Box, LinearProgress } from "@mui/material";
import geoData from "../../../data/world_countries.json";

const UsersPositionOverview = () => {
  
  const data = [
    { id: "AFG", value: 50 },
    { id: "AGO", value: 35 },
    { id: "ALB", value: 20 },
    { id: "USA", value: 100 },
    { id: "CHN", value: 85 },
    { id: "BRA", value: 40 },
    { id: "CAN", value: 45 },
    { id: "FRA", value: 60 },
    { id: "DEU", value: 55 },
    { id: "RUS", value: 30 },
    { id: "AUS", value: 70 },
    { id: "IND", value: 75 },
    { id: "ZAF", value: 25 },
    { id: "EGY", value: 15 },
    { id: "ARG", value: 38 },
  ];

  return (
    <Box m={"1.5rem 2.5rem"}>
      <Box
        height="75vh"
        border={`1px solid #ccc`}
        borderRadius="4px"
        mt="40px"
      >
        {data ? (
          <ResponsiveChoropleth
            data={data}
            theme={{
              axis: {
                domain: {
                  line: {
                    stroke: "#ccc",
                  },
                },
                legend: {
                  text: {
                    fill: "#ccc",
                  },
                },
                ticks: {
                  line: {
                    stroke: "#ccc",
                    strokeWidth: 1,
                  },
                  text: {
                    fill: "#ccc",
                  },
                },
                legends: {
                  text: {
                    fill: "#ccc",
                  },
                },
                tooltip: {
                  container: {
                    color: "#000",
                  },
                },
              },
            }}
            features={geoData.features}
            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
            domain={[0, 100]}
            unknownColor="#666666"
            label="properties.name"
            value="value"
            valueScale={{ type: "linear" }}
            valueFormat=".2s"
            projectionScale={150}
            projectionType="mercator"
            projectionTranslation={[0.5, 0.5]}
            projectionRotation={[0, 0, 0]}
            enableGraticule={true}
            borderWidth={0.5}
            borderColor="#152538"
            legends={[
              {
                anchor: "bottom-left",
                direction: "column",
                justify: true,
                translateX: 20,
                translateY: -100,
                itemsSpacing: 0,
                itemWidth: 94,
                itemHeight: 18,
                itemDirection: "left-to-right",
                itemTextColor: "#ccc",
                itemOpacity: 0.85,
                symbolSize: 18,
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemTextColor: "#ccc",
                      itemOpacity: 1,
                    },
                  },
                ],
              },
            ]}
          />
        ) : (
          <LinearProgress color="primary" />
        )}
      </Box>
    </Box>
  );
};

export default UsersPositionOverview;
